module.exports = __webpack_public_path__ + "img/discount.e54750df.jpg";